module.exports = __webpack_public_path__ + "static/media/centeral.9276f2c4.ogg";